import { render, staticRenderFns } from "./getCateView.vue?vue&type=template&id=75a2ddf7&scoped=true&"
import script from "./getCateView.vue?vue&type=script&lang=js&"
export * from "./getCateView.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a2ddf7",
  null
  
)

export default component.exports